import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state: {
    idRnpPrestador: null,
    isFetched: false,
    pullComplexidades: false,
    payloadComplexidades: [],
    comboComplexidades: [],
    tipoQuestionario: "",
    payloadServidor: {},
    payloadCliente: {}
  },
  mutations,
  actions,
  getters
};
